export function PayoutConfidenceSection() {
  return (
    <div className="space-y-4 xl:hidden">
      <div className="rounded-md border border-emerald-100 bg-emerald-50 px-4 py-3 text-sm leading-relaxed text-gray-700">
        We've paid{" "}
        <span className="font-bold text-emerald-600">50,000+ customers</span>{" "}
        worldwide. Your data is encrypted and never shared.
      </div>
    </div>
  );
}
